export abstract class Logger {
  private prefix = `%cSDK`;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  abstract log(message: string, ...optionalParams: any[]): void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  abstract error(message: string, ...optionalParams: any[]): void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  abstract success(message: string, ...optionalParams: any[]): void;

  getPrefix() {
    return this.prefix;
  }
}
